import CreatorSignUpPage from './components/CreatorSignUpPage'

export default CreatorSignUpPage
